// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/root/workspace/jst-gyl_53Ms/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelAdmin0 from '/root/workspace/jst-gyl_53Ms/src/models/admin.js';
import ModelAdsenseDisplay1 from '/root/workspace/jst-gyl_53Ms/src/models/adsenseDisplay.js';
import ModelAfterSales2 from '/root/workspace/jst-gyl_53Ms/src/models/afterSales.js';
import ModelBookmark3 from '/root/workspace/jst-gyl_53Ms/src/models/bookmark.js';
import ModelCart4 from '/root/workspace/jst-gyl_53Ms/src/models/cart.js';
import ModelContactCustomerService5 from '/root/workspace/jst-gyl_53Ms/src/models/contactCustomerService.js';
import ModelDashboardNum6 from '/root/workspace/jst-gyl_53Ms/src/models/dashboardNum.js';
import ModelDataAuth7 from '/root/workspace/jst-gyl_53Ms/src/models/dataAuth.ts';
import ModelDlz8 from '/root/workspace/jst-gyl_53Ms/src/models/dlz.ts';
import ModelGlobal9 from '/root/workspace/jst-gyl_53Ms/src/models/global.js';
import ModelGoods10 from '/root/workspace/jst-gyl_53Ms/src/models/goods.js';
import ModelLogin11 from '/root/workspace/jst-gyl_53Ms/src/models/login.js';
import ModelModal12 from '/root/workspace/jst-gyl_53Ms/src/models/modal.js';
import ModelNav13 from '/root/workspace/jst-gyl_53Ms/src/models/nav.js';
import ModelOrdersNum14 from '/root/workspace/jst-gyl_53Ms/src/models/ordersNum.js';
import ModelPartnerShop15 from '/root/workspace/jst-gyl_53Ms/src/models/partnerShop.js';
import ModelProgress16 from '/root/workspace/jst-gyl_53Ms/src/models/progress.js';
import ModelRedPonit17 from '/root/workspace/jst-gyl_53Ms/src/models/redPonit.js';
import ModelRedTip18 from '/root/workspace/jst-gyl_53Ms/src/models/redTip.js';
import ModelSetting19 from '/root/workspace/jst-gyl_53Ms/src/models/setting.js';
import ModelSqmallAndOp20 from '/root/workspace/jst-gyl_53Ms/src/models/sqmallAndOp.ts';
import ModelUser21 from '/root/workspace/jst-gyl_53Ms/src/models/user.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'admin', ...ModelAdmin0 });
app.model({ namespace: 'adsenseDisplay', ...ModelAdsenseDisplay1 });
app.model({ namespace: 'afterSales', ...ModelAfterSales2 });
app.model({ namespace: 'bookmark', ...ModelBookmark3 });
app.model({ namespace: 'cart', ...ModelCart4 });
app.model({ namespace: 'contactCustomerService', ...ModelContactCustomerService5 });
app.model({ namespace: 'dashboardNum', ...ModelDashboardNum6 });
app.model({ namespace: 'dataAuth', ...ModelDataAuth7 });
app.model({ namespace: 'dlz', ...ModelDlz8 });
app.model({ namespace: 'global', ...ModelGlobal9 });
app.model({ namespace: 'goods', ...ModelGoods10 });
app.model({ namespace: 'login', ...ModelLogin11 });
app.model({ namespace: 'modal', ...ModelModal12 });
app.model({ namespace: 'nav', ...ModelNav13 });
app.model({ namespace: 'ordersNum', ...ModelOrdersNum14 });
app.model({ namespace: 'partnerShop', ...ModelPartnerShop15 });
app.model({ namespace: 'progress', ...ModelProgress16 });
app.model({ namespace: 'redPonit', ...ModelRedPonit17 });
app.model({ namespace: 'redTip', ...ModelRedTip18 });
app.model({ namespace: 'setting', ...ModelSetting19 });
app.model({ namespace: 'sqmallAndOp', ...ModelSqmallAndOp20 });
app.model({ namespace: 'user', ...ModelUser21 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
